import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { Button } from '../components/ui/button';
import { ShieldOff, Home } from 'lucide-react';

const NoAccess = () => {
  return (
    <Layout>
      <div
        className="flex flex-col items-center justify-center min-h-[60vh] text-center"
        data-testid="no-access-page"
      >
        <div className="w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center mb-6">
          <ShieldOff className="w-10 h-10 text-slate-400" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 font-['Manrope'] mb-2">
          Sin acceso
        </h1>
        <p className="text-slate-500 max-w-md mb-6">
          No tienes permiso para acceder a esta sección. Si crees que esto es un
          error, contacta a un administrador.
        </p>
        <Button asChild data-testid="no-access-home-btn">
          <Link to="/inicio">
            <Home className="w-4 h-4 mr-2" />
            Ir a Inicio
          </Link>
        </Button>
      </div>
    </Layout>
  );
};

export default NoAccess;
